import React from "react";

const Footer = () => {
  return (
    <>
      <footer className="mb-0 bg-info text-dark text-center">
        <div className="d-flex align-items-center justify-content-center pb-5">
          <div className="col-md-6">
            <p className="mb-3 mb-md-0">Design and Developed by {" "} MIS & ICT Division, BSEC</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
